import { Box, Card, CardContent, CardHeader, Skeleton, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

import { useGetDocumentSummary } from '@/api/endpoints/document/useGetDocumentSummary';

interface DocumentSummaryProps {
  documentId: string;
}

const DocumentSummary: React.FC<DocumentSummaryProps> = ({ documentId }) => {
  const summaryQuery = useGetDocumentSummary(documentId);

  if (summaryQuery.isLoading) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardHeader title="Document Summary" />
        <CardContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Skeleton variant="text" width="100%" height={24} />
            <Skeleton variant="text" width="95%" height={24} />
            <Skeleton variant="text" width="90%" height={24} />
            <Skeleton variant="text" width="85%" height={24} />
            <Skeleton variant="text" width="80%" height={24} />
          </Box>
        </CardContent>
      </Card>
    );
  }

  if (summaryQuery.isError) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardHeader title="Document Summary" />
        <CardContent>
          <Typography color="text.secondary">Document summary not available.</Typography>
        </CardContent>
      </Card>
    );
  }

  if (!summaryQuery.data) {
    return null;
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title="Document Summary" />
      <CardContent>
        <ReactMarkdown>{summaryQuery.data}</ReactMarkdown>
      </CardContent>
    </Card>
  );
};

export default DocumentSummary;
